<mat-form-field appearance="outline">
  <mat-label>{{ 'Global.Filter' | translate }}</mat-label>
  <mat-select [(value)]="selectedGroup" (selectionChange)="onSelectionChange.emit(selectedGroup)">
    @for (group of groupList; track group) {
      <mat-option [value]="group._id">
        {{ group.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
